var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPhone = function SvgPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 17.498 17.498"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M8.356 9.148c3.359 3.358 4.121-.526 6.26 1.611 2.062 2.061 3.247 2.474.634 5.086-.327.263-2.406 3.427-9.713-3.878S1.391 2.579 1.654 2.252C4.273-.367 4.679.825 6.74 2.886c2.14 2.137-1.743 2.901 1.616 6.262",
    "data-name": "Path 18604"
  })));
};
export default SvgPhone;